<template>
  <div>
    <p class="version">{{ version }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      version: ''
    }
  },
  created () {
    this.version = process.env.VUE_APP_VERSION
  },
  mounted () {
    this.$nextTick(() => {
      const footer = this.$el
      const footerRect = footer.getBoundingClientRect()
      const body = footer.closest('body')
      body.style.setProperty('--footer-height', footerRect.height + 'px')
    })
  }
}
</script>

<style lang="scss">
footer {
  color: var(--primary-fore-color);
  >div {
    width: 100%;
  }
}
.version {
    position: absolute;
    right: 0px;
    bottom: -12px;
}

</style>
